import { render, staticRenderFns } from "./WillDistribution.vue?vue&type=template&id=5fc9a756"
import script from "./WillDistribution.vue?vue&type=script&lang=js"
export * from "./WillDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports